import { PhotoType } from '@numeo/types-core'
import { uploadErrorText, uploadToLoad } from '../uploads/uploadFlow'
import type { SlotAction } from './LoadRow'

/**
 * The BOL slot's action: its file goes through the board's own upload (`uploadToLoad`, as the chat's upload control does) and what came
 * of it is handed to `onFiled` as the line the row leaves behind. Without a load number there is no upload to make.
 */
export const bolSlotOf = ({
    loadNumber,
    loadId,
    onFiled,
}: {
    loadNumber: string | null | undefined
    loadId?: string
    onFiled: (message: string) => void
}): SlotAction | undefined =>
    loadNumber
        ? {
              label: 'Upload BOL',
              onFile: (file) => {
                  uploadToLoad({ loadNumber, loadId, type: PhotoType.BOL, file })
                      .then((result) =>
                          onFiled(typeof result === 'string' ? result : `${file.name} is a revision of #${loadNumber}: it waits for review on Ongoing Loads`)
                      )
                      .catch((error: unknown) => onFiled(uploadErrorText(error)))
              },
          }
        : undefined
